'use client';

import { NavigableButton } from '@carvana/ds-button';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { NavPayloadAction } from '@carvana/merch-native';
import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useConfiguration } from '~/context/common/StaticContext';

export default function AllCreditTypesCta() {
  const { shouldUseTitleCasing } = useConfiguration();
  const { trackEvent } = useContext(AnalyticsContext);

  function clickHandler() {
    datadogRum.addAction(DATADOG_EVENTS.MARKETING.CLICKS_ALLCREDITTYPES_CTA);
    trackEvent(ANALYTICS_EVENTS.MARKETING.CLICKS_ALLCREDITTYPES_CTA);
  }

  return (
    <NavigableButton
      className="w-full sm:w-auto"
      data-analytics-id="Financing Shop Vehicles Button"
      data-native-payload={JSON.stringify({ action: NavPayloadAction.ViewSrp })}
      href="/cars?refSource=financing"
      size="lg"
      variant="secondary"
      onClick={clickHandler}
      data-testid="shop-vehicles"
    >
      {shouldUseTitleCasing ? 'Shop Vehicles' : 'Shop vehicles'}
    </NavigableButton>
  );
}
